<template>
  <v-container>
    <v-row>
      <v-col>
        <FilePicker :config="config" v-model="value.url" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FilePicker from "../controls/FilePicker.vue";

export default {
  name: "DownloadFileDesigner",

  components: { FilePicker },

  props: ["value", "containers", "component"],

  data() {
    return {
      config: {
        title: "File to download",
        isRequired: true,
        fileType: "*",
      },
    };
  },
};
</script>
